import {
	Footer as AuroraFooter,
	LogoPrimaryAC,
	LogoPrimaryCP,
} from "@consumidor-positivo/aurora";
import { getBrand } from "@shared/services/brandConfig";

const brandMeta = {
	ac: {
		Logo: LogoPrimaryAC,
		copyrights: (
			<>
				© Copyright 2025 Acordo Certo Ltda. <br />
				Todos os direitos reservados / CNPJ: 10.688.174/0001-07
			</>
		),
	},
	cp: {
		Logo: LogoPrimaryCP,
		copyrights: (
			<>
				© Copyright 2025 Consumidor Positivo Ltda. <br />
				Todos os direitos reservados / CNPJ: 30.247.128/0001-15
			</>
		),
	},
};

export const Footer = () => {
	const brand = getBrand();
	const { Logo, copyrights } = brandMeta[brand];

	return (
		<AuroraFooter
			certificates={["sslblindado", "reclameaqui"]}
			copyrights={copyrights}
			logo={<Logo />}
			socialLinks={{
				facebook: "https://facebook.com",
				instagram: "https://instagram.com",
				linkedin: "https://linkedin.com",
				youtube: "https://youtube.com",
			}}
		/>
	);
};
